export class CardKnox {
	transactionId: number;
	locationId: number;
	orderId: number;
	guestId: number;
	guestName: string;
	guestCallName: string;
	currentPaymentAmount: number;
	token: string;
	accountdata: string;
	expiration: string;
	cardNumber: string;
	cardExpiry: string;
	result: string;
	status: string;
	error: string;
	errorCode: string;
	refNum: string;
	authCode: string;
	batch: string;
	avsResultCode: string;
	avsResult: string;
	cvvResultCode: string;
	cvvResult: string;
	authAmount: string;
	cardType: string;
	// transactionRefund: TransactionRefundModel;
	refNumCurrent: string;
	paymentSourceTypeId: number;
	grandTotal: number;
	transactionSourceTypeId: number;
	method: string;
	isAuthOnly: boolean;
	isTabPlus: boolean;
	zipCode: string;
	captureZipCodeOnAllTransactions: boolean;
	isRequiredCaptureZipCode: boolean;
}
